import { SvgIcon } from '@mui/material';
import React from 'react';

export default function CumulativeChartIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 44 44" style={{ width: `22px`, height: `22px`, color: `#1D1D1B`, ...props.style }}>
      <g>
        <rect x="4.21" y="30.94" width="4.2" height="12.58" rx="2.1" ry="2.1" />
        <rect x="14.7" y="24.65" width="4.2" height="18.87" rx="2.1" ry="2.1" />
        <rect x="25.19" y="18.36" width="4.2" height="25.17" rx="2.1" ry="2.1" />
        <rect x="35.67" y="12.06" width="4.2" height="31.46" rx="2.1" ry="2.1" />
        <path d="M39,.87l-3.39-.08-3.39-.08c-.56-.01-.79,.64-.43,1.17l1.05,1.54L5.11,19.97c-.98,.59-1.31,1.86-.72,2.85h0c.59,.98,1.86,1.31,2.85,.72L35.18,6.85l1.06,1.56c.36,.54,1.06,.55,1.25,.03l1.16-3.18,1.16-3.18c.19-.52-.26-1.19-.82-1.2Z" />
      </g>
    </SvgIcon>
  );
}
